import Lookup from 'src/componentes/select2';

const LocalidadeLookup = ({ ...rest }) => (
  <Lookup labelKey="nome" valueKey="id" url="/LocalidadeLookup" {...rest} />
);

export default LocalidadeLookup;
